import { PagiPromiseResponseData, TableRes } from '../global'
import request from '../tools/request'
import { GetLocalStorage, getSupplierId, getUserId } from '../tools/util'
import { HTTP } from './http'
import { FileDTO } from './MaterialApi'
const { GET, POST, downFilePost } = request

export type PaymentRequestItem = {
  applyPrice: number
  createTime: number
  orderCount: number
  orderPaymentId: string
  paymentNo: string
  paymentPrice: number
  paymentStatus: string
  submitMan: string
}

export type PaymentRequestParam = {
  createTimeEnd?: string
  createTimeStart?: string
  pageNo?: number
  pageSize?: number
  paymentNo?: string // 付款单号
  paymentStatus?: string // 付款状态
  schemeId?: string // 搜索方案
}

/**
 * 分页获取付款单申请列表
 * @param params
 * @returns
 */
export const GET_PAYMENT_REQUEST_PAGE = (params: PaymentRequestParam) =>
  GET<TableRes<PaymentRequestItem>>(
    `${HTTP}/orderPayment/getOrderPaymentPage`,
    {
      ...params,
      userId: getUserId(),
    },
  )

export type AllowPaymentItem = {
  paymentMethodList?: string[]
  accountId: string
  accountOpenInvoiceStatus: string
  customer: string
  finalPrice: number
  id: string
  orderId: string
  orderNo: string
  orderPrice: number
  orderState: string
  orderTime: number | string
  platform: string
  returnState: string
  signVoucherState: string
}

export const GET_ALLOW_PAYMENT_PAGE = (params: {
  customer?: string // 客户名称
  orderNo?: string // 客户订单号
  orderTimeEnd?: string
  orderTimeStart?: string
  pageNo?: number
  pageSize?: number
  platform?: string
  schemeId?: string // 搜索方案
  // userId?:string//用户id
}) =>
  GET<TableRes<AllowPaymentItem>>(`${HTTP}/order/getAllowPaymentOrderPage`, {
    ...params,
    userId: getUserId(),
  })

type AddPaymentRequestParam = {
  orderIds: string[]
  paymentPrice: number | string // 付款单金额
  remark: string // 供应商备注
  // userId: string;
}

// 付款申请接口返回值
interface PaymenRequest {
  applyAmount: number // 本次申请付款金额
  countAmount: number // 总应付金额
  countApplyAmount: number // 申请付款中金额
  paymentId: string // 付款单id
  result: boolean // 提交结果
  time: number // 弹窗时间
}
/**
 * 新增付款申请
 * @param params
 * @returns
 */
export const ADD_PAYMENT_REQUEST = (params: AddPaymentRequestParam) =>
  POST<PaymenRequest>(
    `${HTTP}/orderPayment/submitPaymentOrder`,
    {
      ...params,
      userId: getUserId(),
      supplierId: getSupplierId(),
    },
    'application/json',
  )

export type OrderPaymentDetialRes = {
  payOtherDesc: any
  reason: string
  payType: string
  applyPrice: number
  createTime: number | string
  erpPaymentList: {
    erpPaymentNo: string
    id: string
    price: number
    time: string
  }[]
  fillOrderNo: boolean
  id: string
  orderInfoList: {
    customer: string
    customerPayback: string
    finalPrice: number
    id: string
    inputTicketNum: string
    orderId: string
    orderInvoiceStatus: string
    orderNo: string
    orderPrice: number
    orderState: string
    orderTime: number
    platform: string
    signVoucherState: string
  }[]
  paymentList: {
    erpPaymentNo: string
    id: string
    price: number
    time: string
  }[]
  paymentNo: string
  paymentPrice: number
  paymentStatus: string
  productInfoList: {
    accountId: string
    brandName: string
    model: string
    orderNo: string
    productCode: string
    productCount: number
    productId: string
    productName: string
    productPrice: number
    unit: string
  }[]
  remark: string
  submitMan: string
}

export const GET_ORDER_PAYMENT_DETAIL = (params: { paymentId: string }) =>
  GET<OrderPaymentDetialRes>(
    `${HTTP}/orderPayment/getOrderPaymentInfoById`,
    params,
  )

interface ReviewData {
  customerReturnProgressReview: number
  orderId: string
  orderSupplierOpenInvoiceStatusReview: number
  signVoucherStateReview: number
}

// 复核三要素
export const VALIDATE_BY_ORDER_IDS = (params: { orderIdList: string }) =>
  GET<ReviewData[]>(`${HTTP}/order/validateByOrderIds`, params)

export interface CustomerPayback {
  allRefundPrice: number // 已回款金额
  allSalesAmount: number // 总销售金额
  customer: string // 客户名称
  platform: string // 下单平台
  unRefundPrice: number // 未回款金额
}

// 获取客户回款明细
export const GET_CUSTOMER_PAYBACK_LIST = (params: {
  customer?: string
  platform?: string
}) =>
  POST<CustomerPayback[]>(
    `${HTTP}/order/getCustomerPaybackList`,
    {
      ...params,
      supplierId: getSupplierId(),
    },
    'application/json',
  )
type ConstractParam = {
  contractNum?: string // 合同号
  contractType?: string // 合同类型
  enterpriseName?: string // 供应商名称
  landingContractStatus?: string // 合同状态
  signingType?: string // 签订方式
  pageNo: number
  pageSize: number
  schemeId?: string // 搜索方案id
  unit?: string // 单位
  userId?: string // 登陆人Id
  supplierId?: string
}

export interface PageResultLandingContractPageDTO {
  /**
   * 分页内容
   */
  content?: LandingContractPageDTO[]
  /**
   * 当前页码
   */
  pageNo?: number
  /**
   * 分页尺寸
   */
  pageSize?: number
  /**
   * 数据总量
   */
  totalCount?: number
  /**
   * 总页数
   */
  totalPages?: number
  [property: string]: any
}

/**
 * com.xhgj.srm.api.dto.LandingContractPageDTO
 *
 * LandingContractPageDTO
 */
export interface LandingContractPageDTO {
  /**
   * 累计金额
   * 积累金额
   */
  accruingAmounts?: number
  /**
   * 合同号
   */
  contractNo?: string
  /**
   * 合同待签署附件
   */
  contractPendingAttachment?: string
  /**
   * 合同状态
   */
  contractStatus?: string
  /**
   * 合作区域
   */
  cooperationRRegion?: string
  /**
   * 合作有效期
   */
  cooperationValidity?: string
  /**
   * 创建人
   */
  createMan?: string
  /**
   * 创建时间
   */
  createTime?: string
  /**
   * 保证金
   */
  deposit?: number
  /**
   * 保证金状态
   */
  depositState?: boolean
  /**
   * 报备单id
   */
  entryRegistrationOrderId?: string
  /**
   * e签宝流程状态
   */
  eSignProcessStatus?: string
  /**
   * e签宝流程状态
   * e签宝流程状态文案
   */
  eSignProcessStatusValue?: string
  /**
   * 合同附件
   */
  fileDTO?: FileDTO
  /**
   * 附件审核状态
   */
  fileReviewState?: string
  /**
   * id
   */
  id?: string
  /**
   * 税种
   */
  invoiceType?: string
  /**
   * 是否需要绑品
   */
  needBundle?: boolean
  /**
   * 支付方式
   */
  payType?: string
  /**
   * 下单平台编码
   */
  platformCode?: string
  /**
   * 下单平台编码集合
   */
  platformCodeList?: string[]
  /**
   * 项目大类
   */
  projectCategory?: string
  /**
   * 项目全称
   */
  projectName?: string
  /**
   * 报备单号。
   * 报备单号
   */
  registrationNumber?: string
  /**
   * 报备单审核状态
   */
  reportReviewState?: string
  /**
   * 对方签约主体
   */
  secondSigningSupplierId?: string
  /**
   * 签章状态
   */
  signatureStatus?: string
  /**
   * 签署流程错误代码
   */
  signFlowErrorCode?: string
  /**
   * 签署流程错误代码文案
   */
  signFlowErrorCodeValue?: string
  /**
   * 签订方式
   */
  signingType?: string
  /**
   * 税率
   */
  taxRate?: number
  /**
   * 合同类型
   */
  type?: string
  /**
   * 合作类型
   */
  typeOfCooperation?: string
  [property: string]: any
}
// 获取合同信息
export const GET_CONTRACT = (
  params: ConstractParam,
): PagiPromiseResponseData<LandingContractPageDTO[]> =>
  GET(`${HTTP}/frontLandingMerchantContract/frontPage`, params)

export interface FileDetails {
  fileDTO?: FileDTO
  /**
   * 附件审核状态
   */
  fileReviewState?: string
  /**
   * 驳回理由
   */
  reasonForRejection: string
  [property: string]: any
}
// 获取附件状态
export const GET_FILE_STATE = (id: string) =>
  GET<FileDetails>(
    `${HTTP}/frontLandingMerchantContract/detailsOfTheAnnexToTheContract`,
    {
      id,
    },
  )

export const DOWNLOAD_CONTRACT_FILE = (ids: string[]) =>
  downFilePost(
    `${HTTP}/frontLandingMerchantContract/downloadTheContract`,
    { ids, userId: getUserId() },
    'application/json',
    false,
    true,
  )

export const POST_DOWNLOAD_CONTRACT_FILE = (ids: string[]) =>
  POST(
    `${HTTP}/frontLandingMerchantContract/batchDownloadTheContract`,
    { ids, userId: getUserId() },
    'application/json',
  )

export const POST_PRECHECK = (params: any) =>
  POST(`${HTTP}/orderPayment/preCheck`, params, 'application/json')
import { PagiPromiseResponseData, TableRes } from '../global'
import request from '../tools/request'
import { GetLocalStorage, getSupplierId, getUserId } from '../tools/util'
import { HTTP } from './http'
import { FileDTO } from './MaterialApi'
const { GET, POST, downFilePost } = request

export type PaymentRequestItem = {
  applyPrice: number
  createTime: number
  orderCount: number
  orderPaymentId: string
  paymentNo: string
  paymentPrice: number
  paymentStatus: string
  submitMan: string
}

export type PaymentRequestParam = {
  createTimeEnd?: string
  createTimeStart?: string
  pageNo?: number
  pageSize?: number
  paymentNo?: string // 付款单号
  paymentStatus?: string // 付款状态
  schemeId?: string // 搜索方案
}

/**
 * 分页获取付款单申请列表
 * @param params
 * @returns
 */
export const GET_PAYMENT_REQUEST_PAGE = (params: PaymentRequestParam) =>
  GET<TableRes<PaymentRequestItem>>(
    `${HTTP}/orderPayment/getOrderPaymentPage`,
    {
      ...params,
      userId: getUserId(),
    },
  )

export type AllowPaymentItem = {
  paymentMethodList?: string[]
  accountId: string
  accountOpenInvoiceStatus: string
  customer: string
  finalPrice: number
  id: string
  orderId: string
  orderNo: string
  orderPrice: number
  orderState: string
  orderTime: number | string
  platform: string
  returnState: string
  signVoucherState: string
}

export const GET_ALLOW_PAYMENT_PAGE = (params: {
  customer?: string // 客户名称
  orderNo?: string // 客户订单号
  orderTimeEnd?: string
  orderTimeStart?: string
  pageNo?: number
  pageSize?: number
  platform?: string
  schemeId?: string // 搜索方案
  // userId?:string//用户id
}) =>
  GET<TableRes<AllowPaymentItem>>(`${HTTP}/order/getAllowPaymentOrderPage`, {
    ...params,
    userId: getUserId(),
  })

type AddPaymentRequestParam = {
  orderIds: string[]
  paymentPrice: number | string // 付款单金额
  remark: string // 供应商备注
  // userId: string;
}

// 付款申请接口返回值
interface PaymenRequest {
  applyAmount: number // 本次申请付款金额
  countAmount: number // 总应付金额
  countApplyAmount: number // 申请付款中金额
  paymentId: string // 付款单id
  result: boolean // 提交结果
  time: number // 弹窗时间
}
/**
 * 新增付款申请
 * @param params
 * @returns
 */
export const ADD_PAYMENT_REQUEST = (params: AddPaymentRequestParam) =>
  POST<PaymenRequest>(
    `${HTTP}/orderPayment/submitPaymentOrder`,
    {
      ...params,
      userId: getUserId(),
      supplierId: getSupplierId(),
    },
    'application/json',
  )

export type OrderPaymentDetialRes = {
  payOtherDesc: any
  reason: string
  payType: string
  applyPrice: number
  createTime: number | string
  erpPaymentList: {
    erpPaymentNo: string
    id: string
    price: number
    time: string
  }[]
  fillOrderNo: boolean
  id: string
  orderInfoList: {
    customer: string
    customerPayback: string
    finalPrice: number
    id: string
    inputTicketNum: string
    orderId: string
    orderInvoiceStatus: string
    orderNo: string
    orderPrice: number
    orderState: string
    orderTime: number
    platform: string
    signVoucherState: string
  }[]
  paymentList: {
    erpPaymentNo: string
    id: string
    price: number
    time: string
  }[]
  paymentNo: string
  paymentPrice: number
  paymentStatus: string
  productInfoList: {
    accountId: string
    brandName: string
    model: string
    orderNo: string
    productCode: string
    productCount: number
    productId: string
    productName: string
    productPrice: number
    unit: string
  }[]
  remark: string
  submitMan: string
}

export const GET_ORDER_PAYMENT_DETAIL = (params: { paymentId: string }) =>
  GET<OrderPaymentDetialRes>(
    `${HTTP}/orderPayment/getOrderPaymentInfoById`,
    params,
  )

interface ReviewData {
  customerReturnProgressReview: number
  orderId: string
  orderSupplierOpenInvoiceStatusReview: number
  signVoucherStateReview: number
}

// 复核三要素
export const VALIDATE_BY_ORDER_IDS = (params: { orderIdList: string }) =>
  GET<ReviewData[]>(`${HTTP}/order/validateByOrderIds`, params)

export interface CustomerPayback {
  allRefundPrice: number // 已回款金额
  allSalesAmount: number // 总销售金额
  customer: string // 客户名称
  platform: string // 下单平台
  unRefundPrice: number // 未回款金额
}

// 获取客户回款明细
export const GET_CUSTOMER_PAYBACK_LIST = (params: {
  customer?: string
  platform?: string
}) =>
  POST<CustomerPayback[]>(
    `${HTTP}/order/getCustomerPaybackList`,
    {
      ...params,
      supplierId: getSupplierId(),
    },
    'application/json',
  )
type ConstractParam = {
  contractNum?: string // 合同号
  contractType?: string // 合同类型
  enterpriseName?: string // 供应商名称
  landingContractStatus?: string // 合同状态
  signingType?: string // 签订方式
  pageNo: number
  pageSize: number
  schemeId?: string // 搜索方案id
  unit?: string // 单位
  userId?: string // 登陆人Id
  supplierId?: string
}

export interface PageResultLandingContractPageDTO {
  /**
   * 分页内容
   */
  content?: LandingContractPageDTO[]
  /**
   * 当前页码
   */
  pageNo?: number
  /**
   * 分页尺寸
   */
  pageSize?: number
  /**
   * 数据总量
   */
  totalCount?: number
  /**
   * 总页数
   */
  totalPages?: number
  [property: string]: any
}

/**
 * com.xhgj.srm.api.dto.LandingContractPageDTO
 *
 * LandingContractPageDTO
 */
export interface LandingContractPageDTO {
  /**
   * 累计金额
   * 积累金额
   */
  accruingAmounts?: number
  /**
   * 合同号
   */
  contractNo?: string
  /**
   * 合同待签署附件
   */
  contractPendingAttachment?: string
  /**
   * 合同状态
   */
  contractStatus?: string
  /**
   * 合作区域
   */
  cooperationRRegion?: string
  /**
   * 合作有效期
   */
  cooperationValidity?: string
  /**
   * 创建人
   */
  createMan?: string
  /**
   * 创建时间
   */
  createTime?: string
  /**
   * 保证金
   */
  deposit?: number
  /**
   * 保证金状态
   */
  depositState?: boolean
  /**
   * 报备单id
   */
  entryRegistrationOrderId?: string
  /**
   * e签宝流程状态
   */
  eSignProcessStatus?: string
  /**
   * e签宝流程状态
   * e签宝流程状态文案
   */
  eSignProcessStatusValue?: string
  /**
   * 合同附件
   */
  fileDTO?: FileDTO
  /**
   * 附件审核状态
   */
  fileReviewState?: string
  /**
   * id
   */
  id?: string
  /**
   * 税种
   */
  invoiceType?: string
  /**
   * 是否需要绑品
   */
  needBundle?: boolean
  /**
   * 支付方式
   */
  payType?: string
  /**
   * 下单平台编码
   */
  platformCode?: string
  /**
   * 下单平台编码集合
   */
  platformCodeList?: string[]
  /**
   * 项目大类
   */
  projectCategory?: string
  /**
   * 项目全称
   */
  projectName?: string
  /**
   * 报备单号。
   * 报备单号
   */
  registrationNumber?: string
  /**
   * 报备单审核状态
   */
  reportReviewState?: string
  /**
   * 对方签约主体
   */
  secondSigningSupplierId?: string
  /**
   * 签章状态
   */
  signatureStatus?: string
  /**
   * 签署流程错误代码
   */
  signFlowErrorCode?: string
  /**
   * 签署流程错误代码文案
   */
  signFlowErrorCodeValue?: string
  /**
   * 签订方式
   */
  signingType?: string
  /**
   * 税率
   */
  taxRate?: number
  /**
   * 合同类型
   */
  type?: string
  /**
   * 合作类型
   */
  typeOfCooperation?: string
  [property: string]: any
}
// 获取合同信息
export const GET_CONTRACT = (
  params: ConstractParam,
): PagiPromiseResponseData<LandingContractPageDTO[]> =>
  GET(`${HTTP}/frontLandingMerchantContract/frontPage`, params)

export interface FileDetails {
  fileDTO?: FileDTO
  /**
   * 附件审核状态
   */
  fileReviewState?: string
  /**
   * 驳回理由
   */
  reasonForRejection: string
  [property: string]: any
}
// 获取附件状态
export const GET_FILE_STATE = (id: string) =>
  GET<FileDetails>(
    `${HTTP}/frontLandingMerchantContract/detailsOfTheAnnexToTheContract`,
    {
      id,
    },
  )

export const DOWNLOAD_CONTRACT_FILE = (ids: string[]) =>
  downFilePost(
    `${HTTP}/frontLandingMerchantContract/downloadTheContract`,
    { ids, userId: getUserId() },
    'application/json',
    false,
    true,
  )

export const POST_DOWNLOAD_CONTRACT_FILE = (ids: string[]) =>
  POST(
    `${HTTP}/frontLandingMerchantContract/batchDownloadTheContract`,
    { ids, userId: getUserId() },
    'application/json',
  )

export const POST_PRECHECK = (params: any) =>
  POST(`${HTTP}/orderPayment/preCheck`, params, 'application/json')
